import { useState, useEffect } from 'react';
import Category, {
  ClassificationGroup,
  ClassificationItem,
} from '../categories.utility';

const useCategorySearch = (accountTypes: ClassificationGroup[]) => {
  const [searchTerm, setSearchTerm] = useState<string>();
  const [searchTermResults, setSearchTermResults] = useState<
    ClassificationItem[]
  >([]);

  useEffect(() => {
    if (!searchTerm) {
      setSearchTermResults([]);
      return;
    }

    const results = Category.searchCategoryByName({
      searchTerm,
      classifications: accountTypes,
    });

    setSearchTermResults(results);
  }, [accountTypes, searchTerm]);

  const handleSearchTermOnChange = (value: string) => {
    setSearchTerm(value);
  };

  return {
    searchTerm,
    handleSearchTermOnChange,
    searchTermResults,
  };
};

export default useCategorySearch;
